import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useLocation } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import DevicesForm from '@modules/digibesShop/Devices/tabs/digibes/DevicesForm';
import routes from '@routes';
const message = defineMessages({
    objectName: 'Devices',
});

const DevicesSavePage = () => {
    const translate = useTranslate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');

    const { detail, onSave, mixinFuncs, setIsChangedFormValues, isEditing, errors, loading, title } = useSaveBase({
        apiConfig: {
            getById: apiConfig.device.getById,
            create: apiConfig.device.create,
            update: apiConfig.device.update,
        },
        options: {
            getListUrl: generatePath(routes.resDeviceTabsRestaurantListPage.path),
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    status: 1,

                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    status: 1,
                };
            };
        },
    });
    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.restaurantListPage.path),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.resDeviceTabsRestaurantListPage.path)}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <DevicesForm
                id={restaurantId}
                formId={mixinFuncs.getFormId()}
                actions={mixinFuncs.renderActions()}
                dataDetail={detail ? detail : {}}
                onSubmit={onSave}
                setIsChangedFormValues={setIsChangedFormValues}
                isError={errors}
                isEditing={isEditing}
            />
        </PageWrapper>
    );
};
export default DevicesSavePage;
